import { createFileRoute } from '@tanstack/react-router'
import ErrorComponent from '@/features/errors/error-component'
import { zodValidator } from '@tanstack/zod-adapter'
import Index from '@/features/region/countries/pages'
import { searchQueryOptions } from '@/features/region/countries/query-options'
import { SearchSchema } from '@/features/region/countries/schemas/search'

export const Route = createFileRoute('/_authenticated/(region)/countries')({
  component: Index,
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      searchQueryOptions({ key: 'countries', search: deps })
    )
  },
  errorComponent: ({ error }) => {
    return <ErrorComponent error={error} />
  },
})
